import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { CardholderService } from '../../services/cardholder.service';
import { MessageService } from '../../services/message.service';
import {ProfileSearchResult} from '../../data/ProfileSearchResult';

@Component({
  selector: 'app-forms-view-search',
  templateUrl: './forms-view-search.component.html',
  styleUrls: ['./forms-view-search.component.css']
})
export class FormsViewSearchComponent implements OnInit {

  @Input() results: ProfileSearchResult;
  @Output() newFormUploaded = new EventEmitter<void>();
  myFile: File = null;
  upload = false;
  uploadSelected: any = null;

  constructor(private cardholderService: CardholderService, private messageService: MessageService, ) { }

  ngOnInit() {
  }

  handleFileInput(files: FileList) {
    const error = this.checkPdfError(files[0].type);

    if (!error) {
      this.myFile = files[0];
      const element = <HTMLInputElement>document.getElementById('uploadBtn');
      element.disabled = false;
    }
  }


  checkPdfError(type: string) {
    if (type !== 'application/pdf') {
      const errorElement = <HTMLInputElement>document.getElementById('error');
      errorElement.hidden = false;
      const element = <HTMLInputElement>document.getElementById('uploadBtn');
      element.disabled = true;
      return true;
    } else {
      const errorElement = <HTMLInputElement>document.getElementById('error');
      errorElement.hidden = true;
      return false;
    }
  }

  uploadForm(acctNum: string) {
    this.upload = true;
    const file = this.myFile;
    this.cardholderService.uploadForm(acctNum, file).subscribe(
      () => {
        this.upload = false;
        this.messageService.success('The Form was Uploaded Successfully');
        const element = <HTMLInputElement>document.getElementById('uploadBtn');
        element.disabled = true;
        const inputElement = <HTMLInputElement>document.getElementById('myFile');
        inputElement.value = null;
        const errorElement = <HTMLInputElement>document.getElementById('error');
        errorElement.hidden = true;
        this.onFormUploaded();
      },
      data => {
        this.upload = false;
        console.log(data);
        this.messageService.error('There was an error in upload');
      }
    );
  }

  onFormUploaded() {
    this.newFormUploaded.emit();
  }
}
